import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import LocalDB from '../../utils/localDB';
import URLS from '../../utils/urls';


import { printCert, emailCert } from '../../actions/policy';

import BlankState from '../../components/BlankState';
import CertificatePreview from '../../pages/buy/CertificatePreview';
import Modal from '../../components/Modal';
import TagsInput from '../../components/TagsInput';

class GetCertificate extends Component{

	constructor(props){
        super(props);
        
        this.state = LocalDB.fetch("mci_form");
        console.log(this.state);
    }
    
    componentDidMount(){

        this.setState({
            email_send_loading: false,
            receivers: [],
            hasInputFocus: false
        });

        console.log(this.state);
    }

    printCertificate = () => {
        let url = URLS.printCert + this.props.policy.quote.id + '/',
            link = document.createElement('a');
        
        link.href = url;
        link.target = "_blank";
        link.download = url;
        link.click();
    }

    handleTagsUpdate = (name, tags) => {
        this.setState({ [name]: tags });
    }

    emailCertificate = (e) => {
        e.preventDefault();
        
        const { receivers } = this.state;

        if(receivers.length > 0){
            this.setState({ email_send_loading: true });

            this.props.emailCert(this.props.policy.quote, receivers)
                .then((response)=>{
                    this.setState({ email_send_loading: false, receivers: [] });
                })
                .catch((error) => {
                    this.setState({ email_send_loading: false });
                });
        }
        else{
            alert("Enter at least one email address");
        }
    }
	
	render(){
        const {  email_send_loading, currency_rate } = this.state;

        return(
            <div className="clearfix" style={{ minHeight: "30em" }}>
                <h1 className="text-success text-center">
                    <i className="icon ion-ios-checkmark-outline" 
                        style={{ fontSize: "2.5em" }}>
                    </i><br/>
                    Policy successfully created
                </h1>
                <p className="policy-actions text-center">
                    <button 
                        className="btn btn-lg btn-default"
                        data-toggle="modal"
                        data-target=".print-modal" 
                        onClick={ this.printCertificate }>

                        <span className="icon ion-ios-printer-outline"></span>
                        <span>Print Certificate</span>
                    </button>

                    <button 
                        className="btn btn-lg btn-default"
                        data-toggle="modal"
                        data-target=".certificate-modal">
                        <span className="icon ion-eye"></span>
                        <span>Preview Certificate</span>
                    </button>

                    <button 
                        className="btn btn-lg btn-default"
                        data-toggle="modal"
                        data-target=".email-modal"
                        onClick={ ()=>{ this.setState({ hasInputFocus: true }) } }>

                        <span className="icon ion-ios-email-outline"></span>
                        <span>Email Certificate</span>
                    </button>

                    <button 
                        className="btn btn-lg btn-default" 
                        data-toggle="modal"
                        data-target=".policy-modal">
                        <span className="icon ion-document"></span>
                        <span>Policy Document</span>
                    </button>

                    <button 
                        className="btn btn-lg btn-default" 
                        data-toggle="modal"
                        data-target=".icc_clause">
                        <span className="icon ion-document"></span>
                        <span>ICC Clause</span>
                    </button>
                </p>

                <Modal title="Print Certificate" className="print-modal" closable={ true }>
                    <p>Download will begin shortly...</p>
                </Modal>

                <Modal title="Preview Certificate" className="certificate-modal" closable={ true }>
                    
                    <CertificatePreview 
                        quote={ this.props.policy.quote }
                        currency={ currency_rate } />
                </Modal>

                <Modal title="Policy Document" className="policy-modal" closable={ true }>

                    <embed 
                        src={ URLS.siteURL + this.props.policy.quote.insurer_policy_document } 
                        style={{ height: "40em" }} />
                </Modal>

                <Modal title="Email Certificate" className="email-modal" closable={ true }>

                    <div className="form form-horizontal col-sm-12">
                        <div className="form-group">
                            <label className="control-label">Recipients:</label>
                            <div className="clearfix" style={{ marginTop: "1em" }}>
                                
                                <TagsInput 
                                    name="receivers"
                                    onTagsUpdate={ this.handleTagsUpdate } />
                                
                                <small className="text-muted">Multiple emails: Enter an email and press ENTER to add</small>
                            </div>

                            <BlankState 
                                data={ false } 
                                customMessage="Sending email" 
                                isDataLoading={ email_send_loading } />
                        </div>

                        <div className="form-group">
                            <p className="text-info" style={{ fontSize: "1.2em", marginBottom: "2em" }}>
                                <i className="icon ion-paperclip" style={{ fontSize: "1.2em" }}></i> 
                                &nbsp; Attached: Certificate, Policy Doc, ICC Clause
                            </p>
                            <button 
                                className="btn btn-success"
                                onClick={ this.emailCertificate }>
                                <i className="icon ion-paper-airplane"></i> Email Certificate
                            </button>
                        </div>
                    </div>
                </Modal>

                <Modal title="ICC Clause" className="icc_clause" closable={ true }>
                    
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    policy: state.policy
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ printCert, emailCert }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GetCertificate)



// WEBPACK FOOTER //
// ./src/pages/buy/GetCertificate.jsx